import { PhoneInThreed } from './PhoneInThreed.js'

if (typeof window !== 'undefined') {
    window.PhoneInThreed = PhoneInThreed
}

export default PhoneInThreed
